import GLightbox from "glightbox";

document.addEventListener("DOMContentLoaded", function (event) {

    //Mobile Menu Toggle
    const menu_button = document.querySelector('[data-behaviour="toggle-menu"]');

    menu_button.addEventListener('click', () => {
        document.body.classList.toggle('body--show');
    })


    //Lightbox
    const lightbox = GLightbox({
        selector: '[data-gallery="gallery"]',
        touchNavigation: true,
        loop: true,
    });

    //Card Popups
    const cardLightbox = GLightbox({
        selector: '.glightbox-card',
        touchNavigation: true,
        loop: false,
        width: '480px',
    });


    //Openingtimes toggle
    const nav_info_button = document.querySelector('[data-behaviour="opening_times_collapse"]');
    let opening_days = nav_info_button.children[0].children;
    const today_weekday = new Date().toLocaleDateString("de-DE", { weekday: 'long' });

    nav_info_button.addEventListener('click', () => {
        nav_info_button.classList.toggle("expanded");
    })

    for (var i = 0; i < opening_days.length; i++) {
        if (opening_days[i].dataset.weekday == today_weekday) {
            opening_days[i].classList.add("visible");
        }
    }
});
